import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4169E1',
    },
    secondary: {
      main: '#F0F0F0',
    },
    background: {
      default: '#F4F6F8', // Light background for a clean, modern look
      paper: '#FFFFFF', // Paper background to keep sections clean
    },
    text: {
      primary: '#1C1C1E', // Dark text for high readability
      secondary: '#546E7A', // Subtle text for secondary information
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.75rem',
      lineHeight: 1.4,
    },
    button: {
      textTransform: 'none', // Avoid all caps for a more refined look
      fontWeight: 600,
    },
  },
});

export default theme;
